<mat-icon
  [svgIcon]="icons[status]"
  [ngClass]="{
    success: status === 'SUCCESS',
    error: status === 'ERROR',
    info: status === 'RUNNING',
    none: status === 'NONE'
  }"
></mat-icon>